export const queries = {
  mobile: '(max-width: 768px)'
}
